;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    user: {
      type: Object,
      default: function _default() {
        return {
          auth: false,
          data: []
        };
      }
    },
    restoreState: Function
  },
  computed: {
    buttonClass: function buttonClass() {
      return {
        "is-disabled": !this.user.auth
      };
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-autofill"},[_c('button',{staticClass:"ss-autofill__button",class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":function($event){return _vm.restoreState(_vm.user.data)}}},[_vm._v("Указать данные моего авто ")]),(!_vm.user.auth)?_c('p',{staticClass:"ss-autofill__notice"},[_vm._v("(только для "),_c('a',{attrs:{"href":"/login"}},[_vm._v("зарегестрированных пользователей")]),_vm._v(")")]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7fb2da9e", __vue__options__)
  } else {
    hotAPI.reload("data-v-7fb2da9e", __vue__options__)
  }
})()}